export default {
  推荐好友加入: `推荐好友加入`,
  赢取巴塞罗那VIP之旅:'赢取巴塞罗那 <span class="vipWord">VIP</span>之旅',
  成为EBC推荐官: "现在正是推荐好友加入EBC金融集团的最佳时机，让他们体验更优质的交易方式。",
  立即参与: "立即推荐",
  专属奖励等你拿: "专属奖励等你拿",
  西班牙巴塞罗那之旅:'西班牙巴塞罗那之旅',
  巴塞罗那足球俱乐部主场比赛VIP门票:'巴塞罗那足球俱乐部主场比赛VIP门票',
  巴塞罗那足球俱乐部专属晚宴:'巴塞罗那足球俱乐部专属晚宴',
  往返机票酒店住宿当地接送导服务:'往返机票、酒店住宿当地接送导服务',
  您将获得以下奖励:'2025年5月23日前成功推荐66位好友，获得以下奖励',
  如何赢取大奖:'如何赢取大奖',
  登录EBC用户中心: "登录EBC用户中心",
  "进入“大赛推荐官”活动页面": "进入“推荐官”页面",
  生成您的邀请链接或二维码: "生成专属分享链接或二维码",
  成功推荐66人: "成功推荐66人",
  成功推荐奖励:'成功推荐的好友需在活动期问至少入金 ＄500 美元，并完成至少一笔交易',
  你还在等什么:'你还在等什么？',
  EBC为交易者捉供更低点差:'EBC 为交易者捉供更低点差、具竞争力的返佣保障及多项专项福利。我们也希望在巴塞罗那与“你”见面！',
  
  每一次推荐: "每一次推荐，通往巴塞罗那足球俱乐部的黄金助攻",
  参与规则: "参与规则：",
  成为EBC推荐官并邀请66人: "成为EBC推荐官并邀请66人；",
  所有被邀请人均入金大于等于$500: `所有被邀请人均入金大于等于$500，<br class="mobile" />且完成交易。`,
  参与方法: "参与方法",
  立即推荐: "立即推荐，以好友的助力，向传奇致敬",
  
  巴萨荣耀之旅: "巴萨荣耀之旅",
  每笔订单都是攻守博弈的艺术: `每笔订单都是攻守博弈的艺术，<br class="mobile" />每个决策都将缔造资本市场的史诗级射门。`,
  活动时间: "活动时间",
  "2025年2月22日": "2025年2月22日 01:00:00(MT4/MT5时间)-2025年5月23日 23:59:59(MT4/MT5时间)",
  活动规则: "活动规则",
  ruleList: [
    "该活动与正常推荐奖励和其他活动不存在冲突。",
    "被推荐人需完成入金并交易，第三方转账无效。",
    "推荐奖励适用于合规交易者，EBC有权对违规行为取消奖励资格。",
    "通过邀请活动注册的账户不允许转移代理。",
    "获奖以账号有效激活为准，VIP观赛席位含机票和住宿。",
    "本活动最终解释权归EBC金融集团所有。",
  ],
};
